import React, { useState } from 'react';
import ErrorMessages from '../../components/ErrorMessages';
import { Input } from '../../components/forms';
import { ButtonFilled } from '../../components/ui';
import { login } from '../../lib/auth';
import client from '../../lib/client';
import redirect from '../../lib/redirect';
import { acceptAccountMembershipMutation } from '../../queries/account';
import {
  AcceptAccountMembershipMutation,
  AcceptAccountMembershipMutationVariables
} from '../../queries/__generated__/AcceptAccountMembershipMutation';

interface JoinFormProps {
  invitation: {
    id: string;
    invitedMember: {
      displayName: string;
      user: {
        email: string;
        isConfirmed: boolean;
      };
    };
    inviteCode: string;
    acceptedOn: Date;
    revokedOn: Date;
  };
}

const JoinForm: React.FC<JoinFormProps> = ({ invitation }) => {
  const [displayName, setDisplayName] = useState(invitation.invitedMember.displayName);
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState([]);

  async function register() {
    await client
      .mutate<AcceptAccountMembershipMutation, AcceptAccountMembershipMutationVariables>({
        mutation: acceptAccountMembershipMutation,
        variables: { input: { inviteCode: invitation.inviteCode, password } }
      })
      .then(() => {
        login({ variables: { email: invitation.invitedMember.user.email, password } });
        redirect('/');
      });
  }

  return (
    <form
      onSubmit={async event => {
        event.preventDefault();
        register();
      }}
    >
      {errors.length > 0 && (
        <div className="mb3">
          <ErrorMessages errors={errors} />
        </div>
      )}

      <input type="hidden" name="email" value={invitation.invitedMember.user.email} />

      <Input
        label="Name"
        type="text"
        wrapperClassName="mb3"
        defaultValue={invitation.invitedMember.displayName}
        onChange={e => setDisplayName(e.target.value)}
        data-testid="name-input"
      />

      {!invitation.invitedMember.user.isConfirmed && (
        <Input
          label="Password"
          wrapperClassName="mb3"
          type="password"
          name="password"
          onChange={e => setPassword(e.target.value)}
          data-testid="password-input"
        />
      )}

      <div className="tc">
        <ButtonFilled
          type="submit"
          data-testid="register-button"
          disabled={!displayName && (!password || !invitation.acceptedOn)}
        >
          Join
        </ButtonFilled>
      </div>
    </form>
  );
};

export default JoinForm;
